export function getServiceSlug(pathname = window.location.pathname) {
  return pathname.match(/^\/servicos\/([a-z0-9]+(?:-[a-z0-9]+)*)\/?$/)?.[1] || null;
}

export function getServicePath(slug) {
  return `/servicos/${encodeURIComponent(slug)}`;
}
